import { useMutation } from '@tanstack/react-query'
import { oauth2DashboardApi } from '../api/oauth2DashboardApi'
import type { OAuth2RefreshResponse } from '../types/oauth2Dashboard'
import { toast } from '@/integrations/toaster-provider'

export const useRefreshOAuthTokenMutation = (onSuccess: () => void) => {
  return useMutation<OAuth2RefreshResponse>({
    mutationFn: oauth2DashboardApi.refreshToken,
    onSuccess: (data) => {
      if (data.success) {
        toast.success('OAuth2 tokens refreshed successfully')
      } else {
        toast.error(`Token refresh failed: ${data.details || 'Unknown error'}`)
      }
      onSuccess()
    },
    onError: (error: Error) => {
      toast.error(`Token refresh failed: ${error.message || 'Unknown error'}`)
    },
  })
}
